import { useCallback, useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { translate, translations } from '../locales';

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  
  const { language, setLanguage } = context;
  
  const t = useCallback(
    (key: string, params?: Record<string, string | number>): string => {
      return translate(translations[language], key, params);
    },
    [language]
  );

  return {
    t,
    language,
    setLanguage,
  };
};
